export const UNCLEAR_QUERY_MESSAGE = 'The search query is less than the minimum allowed, continue typing...';
export const MAX_RESULTS = 25;
